import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { ClaimStatusEnum } from '../../../lib/enum';
import { isWaitingPeriodWaivedByCause } from '../../../../../lib/claimBenefitCaps.es6';

const ClaimHeader = (props) => {
  const classes = useStyle();

  // BRD §5.6: "Accidental death claims bypass waiting period", and §"Cause of
  // Death-Based Waiting Period Waiver": with Cause of Death = Accident "the waiting
  // period shall be waived entirely, regardless of whether the Date of Death falls
  // within the waiting period." The backend's `is_waiting_period` is computed from
  // dates alone, so an accidental death was still being flagged (retest item 16).
  const claimDetails = (props.claimData && props.claimData.claim_details) || {};
  const claimAdditional = claimDetails.additional_details || {};
  const causeOfDeath =
    claimAdditional.cause_of_death ||
    (props.claimData && props.claimData.cause_of_death) ||
    '';
  const waiverApplies = isWaitingPeriodWaivedByCause(causeOfDeath);
  const inWaitingPeriod =
    props.claimData.is_waiting_period === true && !waiverApplies;

  return (
    <section className={classes.claimsheader}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8} md={8}>
          <div className={classes.claimstitle}>
            <ul>
              <li>{props.claimData.claim_number || "N/A"}</li>
              {
                props.claimData.benefits.map((benfit, index) => {
                  return <li key={index} >- {benfit.type || "N/A"} </li>
                })
              }
              <li><span className={[ClaimStatusEnum.Approved_Paid, ClaimStatusEnum.Approved].includes(props.claimData.status) ? classes.claimStatussuccess : classes.claimStatusdanger}>{props.claimData.status || "N/A"}</span></li>
            </ul>
          </div>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Grid container spacing={2} className={classes.claimactionbtn} style={{ display: (inWaitingPeriod || waiverApplies) ? "block" : "none" }}>
            <Grid item xs={12} sm={12} md={12}>
                <li><span className={classes.waitingPeridod} style={{
                  color: inWaitingPeriod ? "white" : "#000",
                  backgroundColor: inWaitingPeriod ? "red" : "rgba(95, 146, 72, 0.3)"
                }}>{inWaitingPeriod
                  ? "This Claim Benefit is On Waiting Period"
                  : "Waiting period waived — accidental death"}</span></li>
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </section>
  )
}

export default ClaimHeader